import { ApiResponse, User, BusinessUser } from "../../types";
// ==================================================
// 11. PROFILE PAGE
// ==================================================
import React, { useState, useEffect } from 'react';
import apiService from '../../services/ApiService';
export const ProfilePage = () => {
  const [profile, setProfile] = useState({
    personal: {
      name: 'John Doe',
      email: 'john.doe@company.com',
      phone: '+1-555-0123',
      position: 'Business Manager',
      avatar: ''
    },
    company: {
      name: 'TechFlow Solutions',
      industry: 'Technology',
      website: 'https://techflow.com',
      employees: '50-100'
    },
    preferences: {
      theme: 'light',
      notifications: true,
      newsletter: true
    }
  });

  const [isEditing, setIsEditing] = useState(false);

  const handleSaveProfile = async () => {
    try {
      // Save profile API call
      alert('Profile updated successfully!');
      setIsEditing(false);
    } catch (err: any) {
      alert(`Error: ${err.message}`);
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-3xl font-bold text-gray-900">My Profile</h2>
          <p className="text-gray-600">Manage your personal information and preferences</p>
        </div>
        <div className="flex space-x-3">
          {isEditing ? (
            <>
              <button
                onClick={() => setIsEditing(false)}
                className="border border-gray-300 text-gray-700 px-6 py-3 rounded-lg hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                onClick={handleSaveProfile}
                className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700"
              >
                Save Changes
              </button>
            </>
          ) : (
            <button
              onClick={() => setIsEditing(true)}
              className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700"
            >
              Edit Profile
            </button>
          )}
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        
        {/* Profile Card */}
        <div className="bg-white rounded-xl shadow-sm border p-6">
          <div className="text-center">
            <div className="w-24 h-24 bg-gray-300 rounded-full mx-auto mb-4 flex items-center justify-center">
              <span className="text-gray-700 text-2xl font-bold">
                {profile.personal.name.charAt(0).toUpperCase()}
              </span>
            </div>
            <h3 className="text-xl font-bold text-gray-900">{profile.personal.name}</h3>
            <p className="text-gray-600">{profile.personal.position}</p>
            <p className="text-gray-500 text-sm">{profile.company.name}</p>
          </div>
          
          <div className="mt-6 space-y-3">
            <div className="flex items-center text-sm text-gray-600">
              <span className="w-4 h-4 mr-3">📧</span>
              {profile.personal.email}
            </div>
            <div className="flex items-center text-sm text-gray-600">
              <span className="w-4 h-4 mr-3">📞</span>
              {profile.personal.phone}
            </div>
            <div className="flex items-center text-sm text-gray-600">
              <span className="w-4 h-4 mr-3">🌐</span>
              {profile.company.website}
            </div>
          </div>
        </div>

        {/* Personal Information */}
        <div className="bg-white rounded-xl shadow-sm border p-6">
          <h3 className="text-lg font-bold text-gray-900 mb-4">Personal Information</h3>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Full Name</label>
              {isEditing ? (
                <input
                  type="text"
                  value={profile.personal.name}
                  onChange={(e) => setProfile(prev => ({
                    ...prev,
                    personal: { ...prev.personal, name: e.target.value }
                  }))}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
              ) : (
                <p className="text-gray-900">{profile.personal.name}</p>
              )}
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
              {isEditing ? (
                <input
                  type="email"
                  value={profile.personal.email}
                  onChange={(e) => setProfile(prev => ({
                    ...prev,
                    personal: { ...prev.personal, email: e.target.value }
                  }))}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
              ) : (
                <p className="text-gray-900">{profile.personal.email}</p>
              )}
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Phone</label>
              {isEditing ? (
                <input
                  type="tel"
                  value={profile.personal.phone}
                  onChange={(e) => setProfile(prev => ({
                    ...prev,
                    personal: { ...prev.personal, phone: e.target.value }
                  }))}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
              ) : (
                <p className="text-gray-900">{profile.personal.phone}</p>
              )}
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Position</label>
              {isEditing ? (
                <input
                  type="text"
                  value={profile.personal.position}
                  onChange={(e) => setProfile(prev => ({
                    ...prev,
                    personal: { ...prev.personal, position: e.target.value }
                  }))}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
              ) : (
                <p className="text-gray-900">{profile.personal.position}</p>
              )}
            </div>
          </div>
        </div>

        {/* Company Information */}
        <div className="bg-white rounded-xl shadow-sm border p-6">
          <h3 className="text-lg font-bold text-gray-900 mb-4">Company Information</h3>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Company Name</label>
              {isEditing ? (
                <input
                  type="text"
                  value={profile.company.name}
                  onChange={(e) => setProfile(prev => ({
                    ...prev,
                    company: { ...prev.company, name: e.target.value }
                  }))}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
              ) : (
                <p className="text-gray-900">{profile.company.name}</p>
              )}
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Industry</label>
              {isEditing ? (
                <select
                  value={profile.company.industry}
                  onChange={(e) => setProfile(prev => ({
                    ...prev,
                    company: { ...prev.company, industry: e.target.value }
                  }))}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                >
                  <option value="Technology">Technology</option>
                  <option value="Healthcare">Healthcare</option>
                  <option value="Finance">Finance</option>
                  <option value="Retail">Retail</option>
                  <option value="Manufacturing">Manufacturing</option>
                </select>
              ) : (
                <p className="text-gray-900">{profile.company.industry}</p>
              )}
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Website</label>
              {isEditing ? (
                <input
                  type="url"
                  value={profile.company.website}
                  onChange={(e) => setProfile(prev => ({
                    ...prev,
                    company: { ...prev.company, website: e.target.value }
                  }))}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
              ) : (
                <p className="text-gray-900">{profile.company.website}</p>
              )}
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Company Size</label>
              {isEditing ? (
                <select
                  value={profile.company.employees}
                  onChange={(e) => setProfile(prev => ({
                    ...prev,
                    company: { ...prev.company, employees: e.target.value }
                  }))}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                >
                  <option value="1-10">1-10 employees</option>
                  <option value="11-50">11-50 employees</option>
                  <option value="50-100">50-100 employees</option>
                  <option value="100+">100+ employees</option>
                </select>
              ) : (
                <p className="text-gray-900">{profile.company.employees} employees</p>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Preferences */}
      <div className="bg-white rounded-xl shadow-sm border p-6">
        <h3 className="text-lg font-bold text-gray-900 mb-4">Preferences</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="flex items-center justify-between">
            <div>
              <label className="text-sm font-medium text-gray-700">Theme</label>
              <p className="text-xs text-gray-500">Choose your preferred theme</p>
            </div>
            {isEditing ? (
              <select
                value={profile.preferences.theme}
                onChange={(e) => setProfile(prev => ({
                  ...prev,
                  preferences: { ...prev.preferences, theme: e.target.value }
                }))}
                className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              >
                <option value="light">Light</option>
                <option value="dark">Dark</option>
                <option value="auto">Auto</option>
              </select>
            ) : (
              <span className="text-gray-900 capitalize">{profile.preferences.theme}</span>
            )}
          </div>
          
          <div className="flex items-center justify-between">
            <div>
              <label className="text-sm font-medium text-gray-700">Notifications</label>
              <p className="text-xs text-gray-500">Receive push notifications</p>
            </div>
            <input
              type="checkbox"
              checked={profile.preferences.notifications}
              onChange={(e) => setProfile(prev => ({
                ...prev,
                preferences: { ...prev.preferences, notifications: e.target.checked }
              }))}
              disabled={!isEditing}
              className="w-4 h-4 text-blue-600"
            />
          </div>
          
          <div className="flex items-center justify-between">
            <div>
              <label className="text-sm font-medium text-gray-700">Newsletter</label>
              <p className="text-xs text-gray-500">Subscribe to updates</p>
            </div>
            <input
              type="checkbox"
              checked={profile.preferences.newsletter}
              onChange={(e) => setProfile(prev => ({
                ...prev,
                preferences: { ...prev.preferences, newsletter: e.target.checked }
              }))}
              disabled={!isEditing}
              className="w-4 h-4 text-blue-600"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default ProfilePage;
